/* eslint react/prop-types: 0 */

import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalHeader, ModalBody, Form, Input } from "reactstrap";
import InputMask from "react-input-mask";
import { FormGroup, Button } from "semantic-ui-react";
import { SelectPerusahaan } from "../../component/Utils";
import { postDataAction } from "../../config/redux/action";

export const HeaderComp = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.main.dataUser);
  const valuePerusahaan = useSelector((state) => state.main.perusahaanFilter);
  const [modal, setModal] = useState(false);
  const [DataInput, setDataInput] = useState({});
  const [isLoadingButton, setisLoadingButton] = useState(false);

  const handleDataInput = (event) => {
    const { name, value } = event.target;
    setDataInput({
      ...DataInput,
      [name]: name === "role" ? parseInt(value) : value,
    });
  };

  const toggle = () => setModal(!modal);

  const handleSubmit = (e) => {
    e.preventDefault();
    setisLoadingButton(true);
    const NewDataInput = {
      ...DataInput,
      perusahaanId: valuePerusahaan,
    };
    dispatch(
      postDataAction({
        dispatch: "POST_DATA_USER",
        title: "User",
        path: "user",
        body: NewDataInput,
      })
    ).then((res) => {
      setisLoadingButton(false);
      toggle();
      props.getData();
    });
  };

  return (
    <div className="card border-0 rounded-0">
      <div className="container py-4">
        <div className="row px-4">
          <div className="col-md-6 d-flex align-items-center mb-md-0 mb-3">
            <h3>Akun Pengguna</h3>
          </div>
          {user.role < 4 && (
            <div className="col-md-6 d-flex justify-content-end">
              <Button color="blue" onClick={toggle}>
                + &nbsp; Tambah
              </Button>
            </div>
          )}
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Tambah Akun</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <div className="container">
              <FormGroup>
                <Input
                  className="mb-3"
                  type="text"
                  name="name"
                  onChange={handleDataInput}
                  placeholder="Input Name"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Input
                  className="mb-3"
                  type="email"
                  name="email"
                  onChange={handleDataInput}
                  placeholder="Input Email"
                  required
                />
              </FormGroup>
              <FormGroup>
                <InputMask
                  mask="+6\2999999999999"
                  className="form-control mb-3"
                  maskChar={null}
                  placeholder="Input phone number"
                  name="phone"
                  onChange={handleDataInput}
                />
              </FormGroup>
              <Input
                className="mb-3"
                type="select"
                name="role"
                defaultValue="default"
                onChange={handleDataInput}
                required
              >
                <option value="default" disabled>
                  Hak Akses
                </option>
                <option value={1}>Admin</option>
                <option value={2}>Gubernur</option>
                <option value={3}>Biro</option>
                <option value={4}>Komisaris</option>
                <option value={5}>Direksi</option>
                <option value={6}>Keuangan</option>
                <option value={7}>IT</option>
                <option value={8}>SDM</option>
              </Input>
              <FormGroup>
                {DataInput.role > 3 && (
                  <SelectPerusahaan className="w-100" name="perusahaanId" />
                )}
              </FormGroup>
            </div>
            <div>
              <Button
                color="green"
                className="mt-4 w-100"
                disabled={isLoadingButton}
                loading={isLoadingButton}
              >
                Buat Akun
              </Button>
              <Button color="grey" className="mt-3 w-100" onClick={toggle}>
                Cancel
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};
